<div class="container-full-width blue footer" [ngClass]="cssClass">

</div>
